import {
  HeartHandshake,
  Package,
  Users,
  FileCheck2,
  ShieldCheck,
} from "lucide-react";

const ITEMS = [
  {
    icon: HeartHandshake,
    title: "Atención Personalizada",
    desc: "Trato directo, escuchamos lo que necesitás y proponemos soluciones reales.",
  },
  {
    icon: Package,
    title: "Materiales de Calidad",
    desc: "Trabajamos con materiales confiables, sin atajos que comprometan el resultado.",
  },
  {
    icon: Users,
    title: "Equipo Especializado",
    desc: "Cada proyecto se asigna a profesionales con experiencia en ese tipo de obra.",
  },
  {
    icon: FileCheck2,
    title: "Presupuestos Sin Compromiso",
    desc: "Te pasamos un presupuesto claro y detallado, sin obligaciones.",
  },
  {
    icon: ShieldCheck,
    title: "Compromiso y Responsabilidad",
    desc: "Cumplimos los plazos acordados y respondemos por nuestro trabajo.",
  },
];

export default function WhyUs() {
  return (
    <section
      data-testid="whyus-section"
      className="relative bg-[var(--fb-ink)] text-white py-20 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div
        className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full opacity-10 pointer-events-none"
        style={{
          background:
            "radial-gradient(closest-side, rgba(var(--fb-accent-rgb),0.85), transparent 70%)",
        }}
      />

      <div className="relative fb-container">
        <div className="max-w-3xl">
          <span className="eyebrow !text-white/70">
            <span className="!bg-[var(--fb-accent)]"></span>Por qué elegirnos
          </span>
          <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight balance leading-[1.02]">
            Construimos confianza
            <br className="hidden md:block" /> con cada obra.
          </h2>
          <p className="mt-6 text-white/70 text-base md:text-[17px] max-w-2xl pretty">
            Lo que nos diferencia no es una frase de marketing: es la forma en
            la que trabajamos. Estos son los compromisos que asumimos con cada
            cliente.
          </p>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`whyus-card-${i}`}
                className="group bg-white/[0.04] hover:bg-white/[0.08] border border-white/10 rounded-2xl p-6 transition-all duration-500 hover:-translate-y-1 reveal"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--fb-accent)]/15 text-[var(--fb-accent)] group-hover:bg-[var(--fb-accent)] group-hover:text-[var(--fb-ink)] transition-colors">
                  <Icon className="h-5 w-5" strokeWidth={1.75} />
                </span>
                <h3 className="mt-6 font-display text-lg font-semibold tracking-tight">
                  {it.title}
                </h3>
                <p className="mt-2 text-sm text-white/65 leading-relaxed pretty">
                  {it.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
